import * as React from "react";
import { QuestionsIF } from "./QuestionsIF";
import { ClosedMultipleQuestionView } from "./ClosedMultipleQuestionView";
import { useCallback, useMemo } from "react";
import { POSTPARTUM_FEATURE_ID, PREGNANCY_FEATURE_ID } from "shared";
import { useTranslate } from "../../hooks/useTranslate";
import { QualifiedFeature } from "fe-common/graphql";
//region [[ Styles ]]
//endregion [[ Styles ]]
//region [[ Props ]]
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const PregnancyQuestion = (props: QuestionsIF) => {
  const { onAnswer } = props;
  const solverSuggestions = props.question?.suggestions?.map(
    (s) => s.suggestion,
  );
  const { translate } = useTranslate();

  const suggestions = useMemo(() => {
    const pregnancySuggestion = solverSuggestions.find(
      (s) => s.feature.id === PREGNANCY_FEATURE_ID,
    );
    return [
      ...solverSuggestions,
      {
        ...pregnancySuggestion,
        id: `no_${PREGNANCY_FEATURE_ID}`,
        feature: {
          ...pregnancySuggestion.feature,
          shortname: translate("NOT_PREGNANT_SURE"),
        },
        negate: true,
      },
    ];
  }, [solverSuggestions, translate]);

  const handleDone = useCallback(
    (selected) => {
      const val = [...selected.values()].find(([, isSelected]) => isSelected);
      const s: QualifiedFeature = val[0];
      const answer = [s];
      // unfortunately, the model cannot handle this
      // YES pregnant -> YES 'pregnant' + NO 'postpartum'
      // Postpartum -> YES 'postpartum' + NO 'pregnant'
      // SKIP pregnant -> SKIP pregnant + NO 'postpartum'
      // NO pregnant -> NO 'pregnant' + NO 'postpartum'
      const pregnancy = suggestions.find(
        (s) => s.feature.id === PREGNANCY_FEATURE_ID,
      );
      const postpartum = suggestions.find(
        (s) => s.feature.id === POSTPARTUM_FEATURE_ID,
      );
      if (s.feature.id === POSTPARTUM_FEATURE_ID) {
        answer.push({
          ...pregnancy,
          negate: true,
        });
      } else {
        answer.push({
          ...postpartum,
          negate: true,
        });
      }

      onAnswer(answer);
    },
    [onAnswer, suggestions],
  );

  return (
    <ClosedMultipleQuestionView
      questionsText={props.question?.question?.text}
      answer={props.answer?.qfs}
      suggestions={suggestions}
      onDone={handleDone}
      singleSelect={true}
      basedOnReasoning={false}
      isBackgroundQuestion
      miniView={props.miniView}
    />
  );
};
